var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TabLayout',{staticClass:"marketing",attrs:{"tabs":_vm.tabs},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h1',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t('Marketing')))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }